import { Order } from '../types'

export const ORDERS: Order[] = [
  {
    id: '#ZD-1042',
    customer: 'Camila Rodríguez',
    email: 'camila.r@mail.com',
    date: '06 ago 2026',
    total: 4280,
    items: 3,
    status: 'pendiente',
  },
  {
    id: '#ZD-1041',
    customer: 'Martín Pereira',
    email: 'm.pereira@mail.com',
    date: '06 ago 2026',
    total: 1590,
    items: 1,
    status: 'pendiente',
  },
  {
    id: '#ZD-1040',
    customer: 'Lucía Fernández',
    email: 'lucia.f@mail.com',
    date: '05 ago 2026',
    total: 3290,
    items: 2,
    status: 'proceso',
  },
  {
    id: '#ZD-1039',
    customer: 'Diego Sosa',
    email: 'dsosa@mail.com',
    date: '05 ago 2026',
    total: 2190,
    items: 1,
    status: 'enviado',
  },
  {
    id: '#ZD-1038',
    customer: 'Valentina Cabrera',
    email: 'valen.c@mail.com',
    date: '04 ago 2026',
    total: 6480,
    items: 4,
    status: 'enviado',
  },
  {
    id: '#ZD-1037',
    customer: 'Rodrigo Méndez',
    email: 'rodri.mendez@mail.com',
    date: '03 ago 2026',
    total: 990,
    items: 1,
    status: 'entregado',
  },
  {
    id: '#ZD-1036',
    customer: 'Sofía Olivera',
    email: 'sofia.olivera@mail.com',
    date: '02 ago 2026',
    total: 3980,
    items: 2,
    status: 'entregado',
  },
  {
    id: '#ZD-1035',
    customer: 'Nicolás Varela',
    email: 'nvarela@mail.com',
    date: '01 ago 2026',
    total: 1490,
    items: 1,
    status: 'entregado',
  },
]

export const ORDER_STATUS_META: Record<
  Order['status'],
  { label: string; className: string }
> = {
  pendiente: {
    label: 'Pendiente',
    className: 'bg-pink-500/15 text-pink-400 border-pink-500/30',
  },
  proceso: {
    label: 'En proceso',
    className: 'bg-amber-500/15 text-amber-400 border-amber-500/30',
  },
  enviado: {
    label: 'Enviado',
    className: 'bg-teal-500/15 text-teal-400 border-teal-500/30',
  },
  entregado: {
    label: 'Entregado',
    className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
  },
}
